import React from "react";
import DialogHeader from "./footer/DialogHeader";
import DialogFooter from "./footer/DialogFooter";

interface GxDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  size?: "xsmall" | "small" | "medium" | "large" | "xlarge";
  maxHeight?: string;
  showCloseButton?: boolean;
  showAppLogo?: boolean;
  className?: string;
  // Footer props
  showFooter?: boolean;
  requiredMessage?: string;
  confirmMessage?: string;
  cancelBtnTitle?: string;
  submitBtnTitle?: string;
  deleteLabel?: string;
  altariqBtn?: boolean;
  HorizontalLine?: boolean;
  enableAgreeDisAgree?: boolean;
  type?: "submit" | "button" | "reset";
  buttonloading?: boolean;
  submitDisabled?: boolean;
  onBack?: () => void;
  onSubmit?: () => void;
  onDelete?: () => void;
}

export const GxDialog: React.FC<GxDialogProps> = ({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  size = "medium",
  maxHeight = "",
  showCloseButton = true,
  showAppLogo = false,
  className = "",
  showFooter = false,
  requiredMessage = "",
  confirmMessage = "",
  cancelBtnTitle = "Cancel",
  submitBtnTitle = "Submit",
  deleteLabel = "Delete",
  altariqBtn = false,
  HorizontalLine = true,
  enableAgreeDisAgree = false,
  type = "submit",
  buttonloading = false,
  submitDisabled = false,
  onBack,
  onSubmit,
  onDelete,
}) => {
  if (!isOpen) return null;

  const sizeClasses = {
    xsmall: "gx-dialog-xsmall",
    small: "gx-dialog-small",
    medium: "gx-dialog-medium",
    large: "gx-dialog-large",
    xlarge: "gx-dialog-xlarge",
  };

  return (
    <div className="gx-form-dialog-layout">
      <div className={`gx-form-dialog-box ${sizeClasses[size]} ${className}`}>
        {/* Header */}
        {(title || showCloseButton || showAppLogo) && (
          <div className="gx-form-dialog-header">
            <DialogHeader
              handleClose={onClose}
              title={title}
              subtitle={subtitle}
              showAppLogo={showAppLogo}
            />
          </div>
        )}

        {/* Content */}
        <div className={`${maxHeight} gx-form-dialog-content`}>{children}</div>

        {/* Footer - Conditionally rendered */}
        {showFooter && (
          <DialogFooter
            handleClose={onBack || onClose}
            handleFooterSubmit={onSubmit}
            handleDeleteSubmit={onDelete}
            cancel={cancelBtnTitle}
            submit={submitBtnTitle}
            delete={deleteLabel}
            type={type}
            buttonloading={buttonloading}
            submitDisabled={submitDisabled}
            requiredMessage={requiredMessage}
            confirmMessage={confirmMessage}
            altariqBtn={altariqBtn}
            HorizontalLine={HorizontalLine}
            enableAgreeDisAgree={enableAgreeDisAgree}
          />
        )}
      </div>
    </div>
  );
};

export default GxDialog;